export const SET_ORDER = 'STORE/ORDERS/SET_ORDER'
export const SET_ORDERS = 'STORE/ORDERS/SET_ORDERS'
